<template>
  <form @submit.prevent="$emit('create', form)">
    <div class="emd-form-group">
      <label class="emd-label _required lable_title">
        {{ $t('form.name') }}
      </label>
      <input
        v-model="form.name"
        :placeholder="$t('form.name.placeholder')"
        class="emd-input"
        type="text"
      />
    </div>

    <div class="emd-form-group">
      <jade-checkbox
        id="checkbox"
        :value.sync="form.isLegacy"
        :label="$t('form.checkbox')"
      />
    </div>

    <div class="eu-pb_4">
      <label class="emd-label lable_title">
        {{ $t('form.type.title') }}
      </label>
    </div>

    <div class="eu-pb_4">
      <emd-radio
        class="eu-mb_1 _bold"
        name="radio"
        value="all"
        v-model="form.type"
        :label="$t(`form.type.all.label`)"
      />
      <emd-text
        size="small"
        tag="p"
        variation-color="subtle"
        class="eu-ml_5"
        >{{ $t(`form.type.all.description`) }}</emd-text
      >
    </div>
    <div class="eu-pb_4">
      <emd-radio
        class="eu-mb_1 _bold"
        name="radio"
        v-model="form.type"
        value="custom"
        :label="$t(`form.type.custom.label`)"
      />
      <emd-text
        size="small"
        tag="p"
        variation-color="subtle"
        class="eu-ml_5"
        >{{ $t(`form.type.custom.description`) }}</emd-text
      >
    </div>

    <div class="create-key__footer">
      <emd-button
        type="outline"
        color="primary"
        data-testid="close-modal"
        @click="$emit('close')"
      >
        {{ $t('form.button.close') }}
      </emd-button>

      <emd-button
        color="primary"
        data-testid="next"
        type="submit"
        :disabled="$v.form.$invalid"
      >
        {{ $t('form.button.next') }}
      </emd-button>
    </div>
  </form>
</template>

<script>
import { EmdRadio, EmdText, EmdButton } from 'emerald-vue/src/components'
import { required, minLength, maxLength } from 'vuelidate/lib/validators'
import { JadeCheckbox } from '@jade'

export default {
  name: 'CreateKey',

  components: {
    EmdRadio,
    EmdText,
    EmdButton,
    JadeCheckbox
  },

  data () {
    return {
      form: {
        name: '',
        isLegacy: false,
        type: null
      }
    }
  },
  validations: {
    form: {
      name: { required, minLength: minLength(4), maxLength: maxLength(32) },
      type: {
        required
      }
    }
  }
}
</script>

<style scoped>
.lable_title {
  font-size: 14px;
  font-weight: 600px;
}

.create-key__footer {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 8px;
}
</style>

<i18n>
  {
    "pt-BR": {
      "form.name": "Nome da chave",
      "form.name.placeholder": "Ex.: chave do time de marketing",
      "form.checkbox": "Utilizo os módulos legados do Magento 2 ou Woocomerce (Mundipagg)",
      "form.type.title" : "Acesso da chave",
      "form.type.all.label": "Total",
      "form.type.all.description": "Amplo controle sobre operações essenciais da API.",
      "form.type.custom.label": "Personalizado",
      "form.type.custom.description": "Escolha os níveis entre Transacional, Financeiro e Recebedores.",
      "form.button.next": "Avançar",
      "form.button.close": "Fechar"
    },
    "en-US": {
      "form.name": "Key name",
      "form.name.placeholder": "Name secret key",
      "form.checkbox": "I use legacy Magento 2 or Woocomerce (Mundipagg) modules",
      "form.type.title": "Key type access",
      "form.type.all.label": "Full Access",
      "form.type.all.description": "Complete control over essential API operations.",
      "form.type.custom.label": "Customized",
      "form.type.custom.description": "Choose between Transactional, Financial and Receivers levels of access.",
      "form.button.next": "Next",
      "form.button.close": "Close"
    }
  }
</i18n>
